import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Kenyan National ID generator following Single Responsibility Principle
 */
export class KeGenerator extends BaseGenerator {
  generate() {
    // Generate 7 or 8 digit ID
    const length = this.randomInt(7, 8);
    return this.randomDigits(length);
  }
}